import { Flex, Text } from '@mantine/core';
import classes from './HeaderSection.module.css';
import { useTranslation } from 'react-i18next';
const HeaderSection = (props: {
	onSeeAll: () => void;
	title: string;
}) => {
	const { onSeeAll, title } = props;
	const { t } = useTranslation();
	return (
		<Flex justify={'space-between'} align={'center'}>
			<Text className={classes.title}>{title}</Text>
			<Text
				className={classes.linkSeeAll}
				onClick={onSeeAll}
			>
				{t('global.seeAll')}
			</Text>
		</Flex>
	);
};

export default HeaderSection;
